export const truncateString = (baseString: string | undefined, screenWidth: number, widthPercent: number) : string => {
    if(baseString !== undefined) {
        const charactersPermitted : number = (780 / 1300) * screenWidth * (widthPercent/100);
        const truncatedString = baseString!.substring(0, charactersPermitted);
        return truncatedString;
    }
    return "";

}